import { http } from './http';

export const getSmeCouncils = () => {
  return http.get<any>(`sme_councils`);
};
